module.exports = __webpack_public_path__ + "img/UT_Logo_2400_Black_EN.1f85389e.png";